__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-dashboards/v2_12_11/";